import { render, staticRenderFns } from "./lista_memorando.vue?vue&type=template&id=79d20c86&scoped=true"
import script from "./lista_memorando.vue?vue&type=script&lang=js"
export * from "./lista_memorando.vue?vue&type=script&lang=js"
import style0 from "./lista_memorando.vue?vue&type=style&index=0&id=79d20c86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d20c86",
  null
  
)

export default component.exports